module.exports = __webpack_public_path__ + "80c5340f002a6a9bc3ac44dda63e8f30.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/filter_star.png
// module id = 74
// module chunks = 0 1 2 3 4